import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "../ui/button";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "../ui/dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// "Crear Expediente" dialog of the Planning: creates the RES022 dossier of the
// appointment, refreshes the Planning (onCreated) and opens the new dossier.
const CrearExpedienteDialog = ({ open, onOpenChange, appointment, onCreated }) => {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="confirm-create-dossier-dialog">
        <DialogHeader>
          <DialogTitle>Crear Expediente</DialogTitle>
          <DialogDescription>
            ¿Qué tipo de expediente quieres crear para <strong>{appointment?.client_name}</strong>?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col sm:flex-col gap-2">
          <Button
            className="w-full bg-emerald-600 hover:bg-emerald-700"
            data-testid="confirm-create-dossier-res022-btn"
            onClick={async () => {
              onOpenChange(false);
              try {
                toast.loading("Creando expediente RES022...", { id: "create-dossier" });
                const res = await axios.post(`${API}/appointments/${appointment.id}/create-dossier-res022`);
                toast.success("Expediente RES022 creado", { id: "create-dossier" });
                await onCreated();
                navigate(`/dossier-res022/${res.data.dossier_id}`);
              } catch (error) {
                if (!axios.isCancel(error)) toast.error("Error al crear expediente RES022", { id: "create-dossier" });
              }
            }}
          >
            Dossier RES022
          </Button>
          <Button variant="outline" className="w-full" onClick={() => onOpenChange(false)}>Cancelar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CrearExpedienteDialog;
